// @ts-check

/**
 * @file Helpers shared by async model-backed select components.
 */

export const MODEL_SELECT_PAGE_SIZE = 20

/**
 * @typedef {{text: string, value: string}} ModelSelectOption
 * @typedef {{options: ModelSelectOption[], page: number, pageSize: number, totalCount: number}} ModelSelectOptionsResult
 */

/**
 * Normalizes selected values passed by HayaSelect.
 * @param {(string | number)[] | string | number | undefined} values Selected values.
 * @returns {(string | number)[]} Selected values.
 */
export function normalizedSelectValues(values) {
  if (Array.isArray(values)) {
    return values.filter((value) => value != null && String(value).length > 0)
  }
  if (typeof values === "string" || typeof values === "number") {
    return String(values).length > 0 ? [values] : []
  }
  return []
}

/**
 * Builds HayaSelect's paginated options result.
 * @param {object} args Page metadata and rows from a model query.
 * @param {ModelSelectOption[]} args.options Text/value rows for the current page.
 * @param {number} args.page Current page.
 * @param {number} args.totalCount Count across every matching page.
 * @returns {ModelSelectOptionsResult} HayaSelect-compatible paginated payload.
 */
export function modelSelectOptionsResult({options, page, totalCount}) {
  return {
    options,
    page,
    pageSize: MODEL_SELECT_PAGE_SIZE,
    totalCount
  }
}
